import {AccountAssignmentInfo, FullSessionAppointment, SessionAppointment} from 'interfaces';

export type AppointmentsRendererProps = {
    loading: boolean;
    appointments: FullSessionAppointment[];
    renderAssignmentInfo: (assignment: AccountAssignmentInfo) => React.ReactNode;
    renderCreateInfo: (createdAt: string, authSource?: string) => React.ReactNode;
    renderScheduledDates: (schedule: {
        startDate?: string;
        endDate?: string;
    }) => React.ReactNode;
    renderParticipants: (session: SessionAppointment, className?: string) => React.ReactNode;
    renderActions: (session: SessionAppointment) => React.ReactNode;
    getSourceName: (session: SessionAppointment) => string;
    onOpenConnectInfoModal: (data: FullSessionAppointment) => void;
}

export enum AppointmentClientNotificationAction {
    Create = 'create',
    Update = 'update',
    Delete = 'delete'
}